import { render, staticRenderFns } from "./MobileAddSignature.vue?vue&type=template&id=52e0c20d"
import script from "./MobileAddSignature.vue?vue&type=script&lang=js"
export * from "./MobileAddSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports